import { forwardRef, type Ref, type SVGProps } from "react";
const IconListNumberedFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M7.89 10V4h-1.5l-1.477.902v1.383L6.225 5.5h.036V10h1.628z" />
    <path d="M12.79 9h13.42C27.195 9 28 8.1 28 7s-.805-2-1.79-2H12.79C11.805 5 11 5.9 11 7s.805 2 1.79 2" />
    <path d="M12.79 18h13.42c.985 0 1.79-.9 1.79-2s-.805-2-1.79-2H12.79c-.985 0-1.79.9-1.79 2s.805 2 1.79 2" />
    <path d="M26.21 27H12.79c-.985 0-1.79-.9-1.79-2s.805-2 1.79-2h13.42c.985 0 1.79.9 1.79 2s-.805 2-1.79 2" />
    <path d="M4.187 19v-1.156l2.208-1.827a5 5 0 0 0 .376-.34 1.3 1.3 0 0 0 .243-.333.8.8 0 0 0 .087-.379.74.74 0 0 0-.099-.39.64.64 0 0 0-.266-.248.8.8 0 0 0-.393-.09.8.8 0 0 0-.393.09.6.6 0 0 0-.26.263.9.9 0 0 0-.092.422H4.072q0-.625.28-1.076.28-.45.792-.693.51-.243 1.2-.243.71 0 1.23.228.524.226.807.636.285.411.286.963 0 .34-.142.679-.141.334-.508.743-.367.407-1.044.97l-.555.463v.035h2.313V19z" />
    <path d="M5.146 27.763Q5.683 28 6.373 28a3.3 3.3 0 0 0 1.263-.225q.55-.226.858-.622a1.42 1.42 0 0 0 .308-.91 1.18 1.18 0 0 0-.35-.89q-.357-.356-1.064-.433v-.046q.522-.056.861-.37.342-.314.337-.804a1.42 1.42 0 0 0-.28-.876 1.86 1.86 0 0 0-.778-.604A2.8 2.8 0 0 0 6.384 22q-.662 0-1.172.234-.51.233-.804.644-.291.411-.294.947h1.517a.55.55 0 0 1 .1-.314.65.65 0 0 1 .265-.213.9.9 0 0 1 .388-.077q.2 0 .35.074.154.074.24.205a.52.52 0 0 1 .083.302.5.5 0 0 1-.1.314.65.65 0 0 1-.282.214q-.18.077-.416.077h-.594v1.095h.594q.256 0 .453.077a.7.7 0 0 1 .305.214.47.47 0 0 1 .108.314.54.54 0 0 1-.09.319.64.64 0 0 1-.263.22.9.9 0 0 1-.388.076 1 1 0 0 1-.405-.074.7.7 0 0 1-.28-.205.5.5 0 0 1-.102-.302H4q.003.544.308.964t.838.658" />
  </svg>
);
const ForwardRef = forwardRef(IconListNumberedFilledSVG);
ForwardRef.displayName = "IconListNumberedFilled";
export { ForwardRef as IconListNumberedFilled };
